/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/js/aa/requestFlightMiles/requestFlightMiles.js
*    TO   --> ./legacy-web/src/main/assets/js/request-flight-miles/request-flight-miles.js
**/

var RFM_APP = angular.module("RFM_APP", ['ui.router']);

RFM_APP.requestMiles = AAcom("utilities", "ajax", "aaAutoComplete", "airportLookup",function (AAUI) {
});

RFM_APP.config(['$stateProvider', '$urlRouterProvider', '$httpProvider', '$provide',  function($stateProvider, $urlRouterProvider, $httpProvider, $provide){
    $stateProvider.state('request', {
        url: '/request',
        views:{
            'content@': {
                templateUrl : 'searchflights.template',
                controller : 'formSearchController'
            }
        }
    }).state('long', {
        url: '/long',
        views:{
            'content@': {
                templateUrl : 'manualInformation.template',
                controller :  'manualInfoController'
            }
        }
    }).state('review-and-submit', {
        url: '/review-and-submit',
        views:{
            'content@': {
                templateUrl : 'requestMilesSummary.template',
                controller :  'requestMilesSummaryController'
            }
        }
    }).state('request-submitted', {
        url: '/request-submitted',
        views:{
            'content@': {
                templateUrl : 'requestMilesThankyou.template',
                controller :  'requestMilesThankyouController'
            }
        }
    })
    $urlRouterProvider.otherwise('/request');

   	var util = AAcom("utilities", "ajax", "aaDatePicker", function (AAUI) {
	    AAUI.i18n = AAUI.i18n || {};
	    AAUI.i18n.busyFormSubmitText = AAUI.getProperty("loadingTxt");
	    AAUI.util = new aa_Utilities();
	    AAUI.startSpinner = function () {
	        $j("body").aaBusy( { message: util.i18n.busyFormSubmitText} ).start();
	    };
	    AAUI.stopSpinner = function () {
	        $j("body").aaBusy().stop();
	    };
	    $j(document).ready(function () {
	        AAUI.util.aaDialog("aa-request-mileage-link");
	    });
	});

	$httpProvider.interceptors.push(function($q) {
		return {
		    'request': function(config) {
		    	util.startSpinner();
		    	return config || $q.when(config);
		    },
			'requestError': function(rejection){
			   	util.stopSpinner();
			   	return $q.reject(rejection);
			},
			'response': function(response) {
			  	util.stopSpinner();
			   	return response || $q.when(response);
			},
			'responseError': function(rejection) {
			   util.stopSpinner();
			   return $q.reject(rejection);
		    }
		};
	});

}]);

RFM_APP.factory('beforeUnload', function ($rootScope, $window) {
    // Events are broadcast outside the Scope Lifecycle

    /*$window.onbeforeunload = function (e) {
        var confirmation = {};
        var event = $rootScope.$broadcast('onBeforeUnload', confirmation);
        if (event.defaultPrevented) {
            return confirmation.message;
        }
    };*/

    $window.onunload = function () {
        $rootScope.$broadcast('onUnload');
    };
    return {};
}).run(function($window, $rootScope, requestMilesService, beforeUnload) {
    $rootScope.$on("$locationChangeSuccess", function(event, next, current)  {
        if (current.indexOf("#") >= 0 && next != current) {
            requestMilesService.reportToWebAnalytics();
        }
    });


});
